<template>
  <div 
    class="  px-10 mt-12">
    <v-dialog v-model="dialog.status"
            @keydown.esc="dialog.status = false"
            :fullscreen="dialog.fullscreen"
            width="500"
            persistent
            scrollable>
            <v-card 
              :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius-card'"
              class="pa-8 pt-6">
              <v-card-title 
                class="d-flex align-center pa-0 pb-4 text-right popup-header fs-20 font-weight-bold">
                
                Mengubah Status
  
                <v-spacer/>
  
                <!-- <v-icon 
                  @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                  class="cursor-pointer mr-1"
                  size="24"
                  color="#4828a1">
                  {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
                </v-icon>
  
                <v-icon 
                  @click="dialog.status = false; dialog.fullscreen = false; selected.status = [];"
                  class="cursor-pointer"
                  size="24"
                  color="red">
                  mdi-close-circle-outline
                </v-icon> -->
  
                <v-icon 
                  @click="dialog.status = false; dialog.fullscreen = false; message.status = ''; message.error = ''"
                  class="cursor-pointer"
                  size="18"
                  color="#000000">
                  mdi-close
                </v-icon>
              </v-card-title>
              
              <!-- <v-divider 
                class="mb-2"
                style="border-top: 2px dashed #e0e0e0;"/> -->
  
              <v-card-text 
                class="body-1 font-weight-light text-first line-text-second my-0 px-0 py-3">
                Apakah Anda yakin mengubah status data ?

                <v-autocomplete
                  v-if="detail.status === 'diterima driver' || detail.status === 'Set Order'"
                  v-model="status"
                  :items="['diterima driver', 'pengiriman']"
                  
                  label="Pilih Status"
                  multiple
                  dense
                  outlined
                  hide-details
                  style="width: 100%"
                  class="mt-4"
                  >
                </v-autocomplete>

  
                <div v-if="message.error.length > 0"
                  class="text-left mt-4">
                  <div
                    class="error--text d-flex align-start">
                    <v-icon size="18" color="red" style="padding-top: 5px;">mdi-alert-circle-outline</v-icon>
                    
                    <span
                      class="ml-1">
                      {{ message.error }}
                    </span>
                  </div>
                </div>
              </v-card-text>
  
  
              <!-- <v-divider 
                class="mt-2"
                style="border-top: 2px dashed #e0e0e0;"/> -->
  
              <v-card-actions
                class="pa-0 pt-4">
                <v-spacer/>
  
                <v-btn
                  rounded
                  @click="save()"
                  :loading="process.form"
                  :disabled="process.form"
                  width="190"
                  height="45"
                  elevation="0"
                  color="#6948c6"
                  class="fs-16 white--text text-capitalize border-radius">
                  Ya, {{ message.status }}
                </v-btn>
  
                <!-- <v-btn
                  rounded
                  width="120"
                  @click="dialog.status = false; dialog.fullscreen = false; selected.status = [];"
                  :disabled="process.status"
                  outlined
                  class="body-2 font-weight-bold text-capitalize red--text">
                  Batal
                </v-btn> -->
              </v-card-actions>
            </v-card>
          </v-dialog>
    <v-layout wrap>
      <v-flex>
        <section>
          
          <div class="color-dark-blue fs-22 font-weight-bold mb-6">
            Detail BPB
          </div>

          <v-row
            class="mt-3">
            <v-col 
              cols="12"
              class="py-0">
              <v-card 
                flat
                style="border-radius: 25px; border: 1px solid #E7E7E7;">
                <v-card-text
                  v-if="process.load" 
                  class="pb-0 my-4" style="height: 500px; display: flex; align-items: center; justify-content: center;">
                  <div class="text-center">
                    <div class="mb-2 title">
                      Mohon Tunggu...
                    </div>
                    <v-progress-circular
                      indeterminate
                    ></v-progress-circular>
                  </div>
                </v-card-text>

                <v-card-text v-if="!process.load && Object.keys(detail).length > 0">
                  <v-row>
                    <v-col cols="12" md="4">
                      <div>
                        <div class="fs-14" style="margin-bottom: 1px;">
                          No. BPB
                        </div>
                        <div class="fs-16 label-input font-weight-bold">
                          {{ detail.number }}
                        </div>
                      </div>
                    </v-col>
                    <v-col cols="12" md="4">
                      <div>
                        <div class="fs-14" style="margin-bottom: 1px;">
                          Alamat
                        </div>
                        <div class="fs-16 label-input font-weight-bold">
                          {{ detail.customer_shipping_province }}, {{ detail.customer_shipping_city }}, {{ detail.customer_shipping_subdistrict }}
                        </div>
                      </div>
                    </v-col>
                    <v-col cols="12" md="4">
                      <div>
                        <div class="fs-14" style="margin-bottom: 1px;">
                          No. Order
                        </div>
                        <div class="fs-16 label-input font-weight-bold">
                          {{ detail.order_number }}
                        </div>
                      </div>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>

              <v-card flat style="border-radius: 25px; border: 1px solid #E7E7E7;" class="pb-7 mt-6 mb-5">
                <v-card-text>
                  <div class="d-flex align-start">
                    <div class="fs-18 input-label mb-8 font-weight-bold pt-2">
                      Detail Produk
                    </div>
                    <div class="ml-auto">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            @click="exports(detail.id)"
                            :loading="process.export"
                            :disabled="process.export"
                            elevation="0"
                            min-height="28"
                            small
                            min-width="28"
                            color="#bd1112"
                            class="text-capitalize px-0 mx-1"
                            style="border-radius: 6px;"
                            v-bind="attrs"
                            v-on="on">
                            <v-icon size="18" color="white">mdi-file-pdf-box</v-icon>
                          </v-btn>
                        </template>

                        <span>
                          Export Pdf
                        </span>
                      </v-tooltip>
                    </div>
                  </div>
                  <div v-for="(item, index) in varian" :key="index">
                    <!-- {{ index+items.bpb_id }} -->
                    <!-- <table width="100%" style="border-bottom: thin solid #E6EFF5;">
                      <thead>
                        <tr>
                          <th class="text-left fs-14 font-weight-bold pa-2" style="border-top: thin solid #E6EFF5; border-bottom: thin solid #E6EFF5">Nama Barang</th>
                          <th class="text-left fs-14 font-weight-bold pa-2" style="border-top: thin solid #E6EFF5; border-bottom: thin solid #E6EFF5">No. SKU</th>
                          <th class="text-left fs-14 font-weight-bold pa-2" style="border-top: thin solid #E6EFF5; border-bottom: thin solid #E6EFF5">Qty</th>
                          <th class="text-left fs-14 font-weight-bold pa-2" style="border-top: thin solid #E6EFF5; border-bottom: thin solid #E6EFF5">Qty Lusin</th>
                          <th class="text-left fs-14 font-weight-bold pa-2" style="border-top: thin solid #E6EFF5; border-bottom: thin solid #E6EFF5">Qty Dus</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(item, index) in form.varian_arr" :key="index">
                          <td class="text-left label-input fs-16 font-weight-bold pa-2">{{ item.detail_varian_name }}</td>
                          <td class="text-left label-input fs-16 font-weight-bold pa-2">{{ item.detail_varian_sku }}</td>
                          <td class="text-left label-input fs-16 font-weight-bold pa-2">{{ item.detail_qty_pcs_approved }}</td>
                          <td class="text-left label-input fs-16 font-weight-bold pa-2">{{ item.detail_qty_lusin_approved }}</td>
                          <td class="text-left label-input fs-16 font-weight-bold pa-2">{{ item.detail_qty_dus_approved }}</td>
                        </tr>
                      </tbody>
                    </table> -->
                    <v-card flat class="mb-5" style="background: #4828a117; border-radius: 15px;">
                      <v-card-text>
                        <div class="fs-16 font-weight-bold label-input">
                          {{ item.varian_name }}
                        </div>
                        <div>
                          <span>Kode SKU</span>: <span>{{ item.varian_sku }}</span>
                        </div>
                        <!-- <div>
                          <span>Harga</span>: <span>{{ item.price | price }}</span>
                        </div> -->

                        <v-row class="pt-3 pb-0">
                          <v-col class="py-0" cols="12" md="4">
                            <div 
                              class="fs-15 label-input">
                              Qty yang akan dikirim
                            </div>
                          </v-col>
                          <!-- <v-col class="py-0" cols="3">
                            <div 
                              class="fs-15 label-input">
                              Qty yang akan dikirim
                            </div>
                          </v-col> -->
                        </v-row>

                        <v-row v-if="item.qty_pcs*1 > 0">
                          <!-- <v-col>
                            <div class="fs-15 label-input">
                              Harga
                            </div>
    
                            <div class="fs-19 font-weight-bold label-input">
                              {{ item.price | price }}
                            </div>
                          </v-col> -->

                          <v-col class="py-0" cols="12" md="4">
      
                            <div class="fs-19 font-weight-bold label-input">
                              {{ item.qty_pcs }} Pcs
                            </div>
                            <!-- <div class="fs-15 label-input">
                              Qty
                            </div>
    
                            <v-currency-field
                              
                              filled
                              rounded
                              dense
                              solo
        
                              color="#4828a1"
                              placeholder="Qty"

                              
        
                              v-model="item.qty"
                              required
                              style="border-radius: 10px;">
                            </v-currency-field> -->
                          </v-col>
                          <!-- <v-col class="py-0" cols="3">
                            <ValidationProvider
                              :name="`Qty Pcs ${item.varian_name}`"
                              :rules="`required|max_value:${item.qty_pcs_approve}|min_value:0`" 
                              v-slot="{ errors }">
        
                              <v-currency-field
                              
                                filled
                                rounded
                                dense
                                solo
          
                                color="#4828a1"
                                placeholder="Qty"
                                suffix="pcs"
          
                                :value="item.qty_pcs"
                                :error-messages="errors"
                                required
                                style="border-radius: 10px;">
                              </v-currency-field>
                            </ValidationProvider>
                          </v-col> -->

                          <!-- <v-col>
                            <div class="fs-15 label-input">
                              Harga Beli
                            </div>
    
                            <v-currency-field
                              
                              filled
                              rounded
                              dense
                              solo
        
                              color="#4828a1"
                              placeholder="Harga Beli"
                              
        
                              v-model="item.harga_beli"
                              required
                              style="border-radius: 10px;">
                            </v-currency-field>
                          </v-col>

                          <v-col>
                            <div class="fs-15 label-input">
                              PPN Beli
                            </div>
    
                            <v-currency-field
                              
                              filled
                              rounded
                              dense
                              solo
        
                              color="#4828a1"
                              placeholder="PPN Beli"
                              
        
                              v-model="item.ppn_beli"
                              required
                              style="border-radius: 10px;">
                            </v-currency-field>
                          </v-col> -->
                        </v-row>

                        <v-row v-if="item.qty_lusin*1 > 0">
                          <!-- <v-col>
                            <div class="fs-15 label-input">
                              Harga
                            </div>
    
                            <div class="fs-19 font-weight-bold label-input">
                              {{ item.price | price }}
                            </div>
                          </v-col> -->

                          <v-col class="py-0" cols="12" md="4">
      
                            <div class="fs-19 font-weight-bold label-input">
                              {{ item.qty_lusin }} Lusin
                            </div>
                            <!-- <div class="fs-15 label-input">
                              Qty
                            </div>
    
                            <v-currency-field
                              
                              filled
                              rounded
                              dense
                              solo
        
                              color="#4828a1"
                              placeholder="Qty"

                              
        
                              v-model="item.qty"
                              required
                              style="border-radius: 10px;">
                            </v-currency-field> -->
                          </v-col>
                          <!-- <v-col class="py-0" cols="3">
                            <ValidationProvider
                              :name="`Qty Lusin ${item.varian_name}`"
                              :rules="`required|max_value:${item.qty_lusin_approve}|min_value:0`" 
                              v-slot="{ errors }">
        
                              <v-currency-field
                              
                                filled
                                rounded
                                dense
                                solo
          
                                color="#4828a1"
                                placeholder="Qty"
                                suffix="lusin"
                                
          
                                :value="item.qty_lusin"
                                :error-messages="errors"
                                required
                                style="border-radius: 10px;">
                              </v-currency-field>
                            </ValidationProvider>
                          </v-col> -->

                          <!-- <v-col>
                            <div class="fs-15 label-input">
                              Harga Beli
                            </div>
    
                            <v-currency-field
                              
                              filled
                              rounded
                              dense
                              solo
        
                              color="#4828a1"
                              placeholder="Harga Beli"
                              
        
                              v-model="item.harga_beli"
                              required
                              style="border-radius: 10px;">
                            </v-currency-field>
                          </v-col>

                          <v-col>
                            <div class="fs-15 label-input">
                              PPN Beli
                            </div>
    
                            <v-currency-field
                              
                              filled
                              rounded
                              dense
                              solo
        
                              color="#4828a1"
                              placeholder="PPN Beli"
                              
        
                              v-model="item.ppn_beli"
                              required
                              style="border-radius: 10px;">
                            </v-currency-field>
                          </v-col> -->
                        </v-row>

                        <v-row v-if="item.qty_dus*1 > 0">
                          <!-- <v-col>
                            <div class="fs-15 label-input">
                              Harga
                            </div>
    
                            <div class="fs-19 font-weight-bold label-input">
                              {{ item.price | price }}
                            </div>
                          </v-col> -->

                          <v-col class="py-0" cols="12" md="4">
                            
                            <div class="fs-19 font-weight-bold label-input">
                              {{ item.qty_dus }} dus
                            </div>
        
                              
                            <!-- <div class="fs-15 label-input">
                              Qty
                            </div>
    
                            <v-currency-field
                              
                              filled
                              rounded
                              dense
                              solo
        
                              color="#4828a1"
                              placeholder="Qty"

                              
        
                              v-model="item.qty"
                              required
                              style="border-radius: 10px;">
                            </v-currency-field> -->
                          </v-col>
                          <!-- <v-col class="py-0" cols="3">
                            <ValidationProvider
                              :name="`Qty Dus ${item.varian_name}`" 
                              :rules="`required|max_value:${item.qty_dus_approve}|min_value:0`" 
                              v-slot="{ errors }">
        
                              <v-currency-field
                              
                                filled
                                rounded
                                dense
                                solo
          
                                color="#4828a1"
                                placeholder="Qty"
                                suffix="dus"
                                
          
                                :value="item.qty_dus"
                                :error-messages="errors"
                                required
                                style="border-radius: 10px;">
                              </v-currency-field>
                            </ValidationProvider>
                          </v-col> -->

                          <!-- <v-col>
                            <div class="fs-15 label-input">
                              Harga Beli
                            </div>
    
                            <v-currency-field
                              
                              filled
                              rounded
                              dense
                              solo
        
                              color="#4828a1"
                              placeholder="Harga Beli"
                              
        
                              v-model="item.harga_beli"
                              required
                              style="border-radius: 10px;">
                            </v-currency-field>
                          </v-col>

                          <v-col>
                            <div class="fs-15 label-input">
                              PPN Beli
                            </div>
    
                            <v-currency-field
                              
                              filled
                              rounded
                              dense
                              solo
        
                              color="#4828a1"
                              placeholder="PPN Beli"
                              
        
                              v-model="item.ppn_beli"
                              required
                              style="border-radius: 10px;">
                            </v-currency-field>
                          </v-col> -->
                        </v-row>

                      </v-card-text>
                    </v-card>
                  </div>

                </v-card-text>
              </v-card>

              
            </v-col>
          </v-row>

          <v-row
            justify="end"
            class="pa-4 pr-1">
            <v-col 
              cols="12"
              md="12"
              class="d-flex align-center justify-end py-0">

              <!-- <v-btn 
                @click="dialog.status = true; message.error = ''; detail.status == 'Set Order' ? status = 'diterima driver' : detail.status == 'diterima driver' ? status = 'pengiriman' : status = 'diterima customer'"
                :loading="process.load"
                :disabled="process.load"
                v-if="detail.status !== 'diterima customer'"
                width="150"
                height="45"
                elevation="0"
                color="#6948c6"
                class="fs-16 white--text text-capitalize border-radius">
                Ubah Status
              </v-btn> -->
              
              <v-btn
                to="/delivery/bpb"
                color="red"
                elevation="0"
                width="140"
                height="45"
                class="body-2 white--text text-capitalize d-flex align-center ml-4 border-radius"
                style="font-weight: 600;">
              
                  Kembali
              </v-btn>
            </v-col>
          </v-row>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { TokenService } from "@/service/Storage.Service";
  import { get, post, put, patch, destroy } from "@/service/Axios";
  import axios from "axios";
  import moment from "moment"
  import "moment/locale/id"
  export default {
    data () {
      return {
        approved_by: [],
        approved_reason: '',
        date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
        menu: false,
        modal: false,
        menu2: false,
        
        zoomed: false,
        zoomedTtd: false,
        imageAspectRatio: 1,
        imageAspectRatioTtd: 1,

        dialog: {
          status: false
        },
        status: '',

        detail: {},
        varian: [],

        rejected_reason: '',

        form: {
          id: '',
          sales_id: '',
          name_alias: '',
          name: '',
          mobilephone_arr: [],
          email: '',
          nik: '',
          npwp: '',
          plafon: '',
          faktur: '',
          term: '',
          ttd: ''
        },
        category: [],
        branch: [],

        mobilephone: {
          name: '',
          id: ''
        },

        upload: {
          ttd: null,
          image_url: null
        },

        process: {
          form: false,

          load: false,

          image_url: false,
          export: false
        },
        
        message: {
          success: '',
          error: '',
          status: ''
        }
      }
    },
    components: {
      uploadfolder: () => import(/* webpackPrefetchCategory: true */ '@/components/upload/folder.vue')
    },
    watch: {
      
    },
    computed: {
      user () {
        return this.$store.state.user
      },
      rps () {
        return this.$vuetify.breakpoint.name
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      }
    },
    mounted () {
      this.fetchList()
    },
    methods: {
      async fetchList () {
        this.process.load = true
        let params = {
          d: this.$route.params.id
        }

        await get('admin/bpb/data', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.detail = res.results.data[0]
            this.fetchDetail()
          }
          // this.process.load = false
        })
      },
      async fetchDetail () {
        this.process.load = true
        let params = {
          bpb_id: this.$route.params.id
        }

        await get('admin/bpb/detail', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.varian = res.results.data.data
          }
          this.process.load = false
        })
      },
      reset (index) {
        if (this.$refs.form) this.$refs.form.reset()
        
        this.rejected_reason = ''

        this.process.form = false

        this.message.error = ''
      },
      onImageLoad(e) {
        const img = e.target
        this.imageAspectRatio = img.naturalWidth / img.naturalHeight
      },
      onImageLoadAkta(e) {
        const img = e.target
        this.imageAspectRatioAkta = img.naturalWidth / img.naturalHeight
      },

      async save () {
        this.message.error = ''
        const isValid = true
        if (isValid) {
          

        this.process.form = true

        await post(`admin/delivery/update_status_driver`, {
          data: {
            id: this.detail.id,
            status: this.status,
          }
        }).then(response => {
          let res = response.data

          this.process.form = false

          if (res.status === 200) {

            this.dialog.status = false

            
            this.dialog.snackbar = true
            this.message.success = res.message

            this.dialog.fullscreen = false

            this.fetchDetail()
          } else {
            this.message.error = res.message
          }
        })
          
        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }

        
      },

      async exports (id) {
        this.message.error = ''

        this.process.export = true

        let params = {
          bpb_id: id
        }

        await axios({
          url: `${process.env.VUE_APP_API_URL}admin/bpb/export_pdf`,
          method: 'GET',
          responseType: 'blob', // important,
          params: params,
          headers: {
            Authorization: process.env.VUE_APP_XAUTH,
            token: TokenService.getToken()
          }
        }).then((response) => {
          let res = response

          this.process.export = false
          console.log(res.headers)
          let disposition = res.headers['content-disposition']
          // console.log(disposition)
          var fileName = res.headers['content-disposition'].split('filename=\"')[1]
          let filename = ''

          if (disposition && disposition.indexOf('inline') !== -1) {
            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            var matches = filenameRegex.exec(disposition);
            if (matches != null && matches[1]) { 
              filename = matches[1].replace(/['"]/g, '');
            }
          }
          // console.log(filename)

          if (res.status === 200) {
            this.dialog.snackbar = true
            this.message.success = 'Berhasil mengeksport pdf'

            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url

            link.setAttribute('download', filename)
            document.body.appendChild(link)

            link.click()
          } else {
            this.message.error = res.message
          }
        })
      }
    }
  }
</script>